import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable, Subject} from 'rxjs';
import {EnumService} from '@ispm/user/services/enum.service';
import {TestService} from '@ispm/dashboard/test/services/test.service';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";


@Component({
  selector: 'gen-navican-sample-form',
  templateUrl: './navican-sample-form.component.html',
  styleUrls: ['./navican-sample-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavicanSampleFormComponent implements OnInit {
  public tunnel$: Subject<any>;
  public callback: (model, testId, limsWorkflow, workflowRequestTemplateId) => Observable<Response>;
  public navicanSampleForm: FormGroup;
  public submitted: boolean = false;
  public histopatologies: any[];
  public sites: any[];

  private testId: string;

  constructor(private detector: ChangeDetectorRef,
              private EnumService : EnumService,
              public testService : TestService,
              private routerManagerService: RouterManagerService) {
    this.testId = this.routerManagerService.parameters.testId;
  }

  ngOnInit() {
    this.navicanSampleForm = new FormGroup({
      externalId: new FormControl('', Validators.required),
      shipperId: new FormControl(''),
      histopathology: new FormControl('', Validators.required),
      site: new FormControl('', Validators.required),
      collection: new FormGroup({
        method: new FormControl('', Validators.required),
        collectedDateTime: new FormControl(null, Validators.required)
      }),
      type: new FormControl({ code: 'FFPE', display: 'FFPE'}, Validators.required),
      tumorPercentage: new FormControl('', [Validators.min(1), Validators.max(100)]),
      receivedTime: new FormControl((<any> new Date()).toPlatformFormat(), Validators.required),
      printer: new FormControl(null),
      returned: new FormControl(''),
      returnNotes: new FormControl('')
    });
    this.tunnel$.asObservable()
      .filter(value => value.emitter !== 'child')
      .subscribe(next => {
        next.value && this.Submit(this.navicanSampleForm.value, this.navicanSampleForm.valid);
      });
  }

  Submit(model, isValid: boolean) {
    this.submitted = true;
    try {
      this.detector.detectChanges();
    } catch(err) {
      console.error("navican-sample-form component: ChangeDetectRef was destroyed.");
    }
    if (isValid) {
      /*      model.identifiers = [];
            let id = `${(new Date()).getFullYear().toString().slice(2, 4)}-${this.randomString(6)}`;
            model.identifiers.push(id);*/
      model.genomicsFiles = [];
      // let pathAndFileName = this.getFileNameAndPath(id);
      for (const testInput of this.testService.testConfiguration.specimenConfig[0].testInputFiles) {
        const prefixPathAndFileName = this.getFileNameAndPath(testInput.prefix);
        model.genomicsFiles.push({
          'storageName': this.testService.testConfiguration.storageName || 'PAPAyA',
          'path': prefixPathAndFileName.path,
          'prefix': prefixPathAndFileName.fileName,
          'suffix': testInput.suffix
        });
      }
      model.objectType = 'navican';
      // model.accessionIdentifier = {value: `${id}-temp`};
      this.callback(model, this.testId, this.testService.testConfiguration.limsWorkflowId, this.testService.testConfiguration.id).subscribe((res) => {
        this.tunnel$.next({ emitter: 'child', value: res});
      });
    }
  }

  getFileNameAndPath(specimenSampleId) {
    const pathAndFileName: any = { };
    const splittedFileName = specimenSampleId.split('/');
    if (splittedFileName.length > 1) {
      pathAndFileName.fileName = splittedFileName.splice(-1, 1)[0];
      pathAndFileName.path = splittedFileName.join('/');
    }
    else {
      pathAndFileName.fileName = splittedFileName[0];
      pathAndFileName.path = '';
    }
    return pathAndFileName;
  }

  randomString(length) {
    return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
  }

  getHistopathologies(event) {
    this.EnumService.getHistopathologies(event.query).subscribe((res) => {
      this.histopatologies = res.json();
      try {
        this.detector.detectChanges();
      } catch(err) {
        console.error("navican-sample-form component: ChangeDetectRef was destroyed.");
      }
    });
  }

  compareBy(a: any, b: any) {
    return a && b ? a.code === b.code : a === b;
  }

  getSites(event) {
    if (event.query.length > 0) {
      this.EnumService.getTopology(event.query).subscribe((res) => {
        this.sites = res.json();
        try {
          this.detector.detectChanges();
        } catch(err) {
          console.error("navican-sample-form component: ChangeDetectRef was destroyed.");
        }
      });
    }
    else {
      this.sites = [];
    }
  }

  trackByFn(item, index) {
    return item ? item.code : index;
  }
}
